(() => {
  const init = () => {
    document.querySelectorAll('[data-zevra-gallery]').forEach((gallery) => {
      if (gallery.dataset.zevraGalleryReady === 'true') return;
      gallery.dataset.zevraGalleryReady = 'true';
      const root = gallery.closest('[data-zevra-product]');
      const main = gallery.querySelector('[data-zevra-main-image]');
      const thumbsContainer = gallery.querySelector('[data-zevra-thumbs]');
      let thumbs = [];

      const showImage = (index, options = {}) => {
        const thumb = thumbs[index];
        if (!main || !thumb?.dataset.full) return;
        const source = window.matchMedia('(max-width: 700px)').matches
          ? (thumb.dataset.mobile || thumb.dataset.full)
          : thumb.dataset.full;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = source;
        main.alt = thumb.dataset.alt || main.alt;
        thumbs.forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
        if (options.scroll !== false) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      };

      const bindThumbs = () => {
        thumbs = Array.from(gallery.querySelectorAll('[data-full]'));
        thumbs.forEach((thumb, index) => {
          if (thumb.dataset.zevraThumbReady === 'true') return;
          thumb.dataset.zevraThumbReady = 'true';
          thumb.addEventListener('click', () => showImage(index));
        });
      };

      const renderVariantGallery = (variantId) => {
        if (!root || !thumbsContainer || !variantId) return;
        const template = Array.from(root.querySelectorAll('[data-zevra-gallery-template]'))
          .find((item) => item.dataset.zevraGalleryTemplate === String(variantId));
        if (!template) return;
        thumbsContainer.replaceChildren(template.content.cloneNode(true));
        gallery.dataset.currentVariant = String(variantId);
        bindThumbs();
        showImage(0, { scroll: false });
      };

      gallery.addEventListener('zevra:variant-gallery', (event) => {
        renderVariantGallery(event.detail?.variantId);
      });

      bindThumbs();

      const mainPhoto = gallery.querySelector('.main-photo');
      if (mainPhoto) {
        let touchStartX = 0;
        let touchStartY = 0;
        mainPhoto.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });
        mainPhoto.addEventListener('touchend', (event) => {
          if (thumbs.length < 2) return;
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          const activeIndex = Math.max(0, thumbs.findIndex((item) => item.classList.contains('active')));
          const nextIndex = deltaX < 0
            ? (activeIndex + 1) % thumbs.length
            : (activeIndex - 1 + thumbs.length) % thumbs.length;
          showImage(nextIndex);
        }, { passive: true });
      }
    });


    document.querySelectorAll('[data-zevra-variant-picker]').forEach((picker) => {
      if (picker.dataset.zevraVariantReady === 'true') return;
      picker.dataset.zevraVariantReady = 'true';
      const root = picker.closest('[data-zevra-product]');
      const radios = Array.from(picker.querySelectorAll('input[type="radio"]'));
      const applyVariant = (radio) => {
        if (!root || !radio) return;
        const preorder = radio.dataset.preorder === 'true';
        root.querySelectorAll('[data-zevra-variant-input]').forEach((input) => {
          input.value = radio.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        picker.querySelectorAll('.zevra-colour-option').forEach((option) => {
          option.classList.toggle('selected', option.contains(radio));
        });
        const setText = (selector, value) => {
          const element = root.querySelector(selector);
          if (element) element.textContent = value || '';
          return element;
        };
        setText('[data-zevra-colour-name]', radio.dataset.title);
        setText('[data-zevra-price]', radio.dataset.price);
        const compare = setText('[data-zevra-compare]', radio.dataset.compare);
        const saving = root.querySelector('[data-zevra-saving]');

if (saving) {
  if (radio.dataset.saving) {
    saving.innerHTML = preorder
      ? `Pre-order: Early <span class="black-friday-text">BLACK 🖤 FRIDAY</span> SALE : You SAVE ${radio.dataset.saving} + FREE SHIPPING`
      : `Early <span class="black-friday-text">BLACK 🖤 FRIDAY</span> SALE : You SAVE ${radio.dataset.saving} + FREE SHIPPING`;
  } else {
    saving.innerHTML = '';
  }
}
        if (compare) compare.hidden = !radio.dataset.compare;
        if (saving) saving.hidden = !radio.dataset.saving;
        const delivery = setText('[data-zevra-delivery-note]', preorder
          ? 'Orders ship from mid-November.'
          : 'In your clutch in 2–8 days');
        delivery?.classList.toggle('is-preorder', preorder);
        const stock = root.querySelector('[data-zevra-stock-note]');
        if (stock) stock.hidden = preorder;
        setText('[data-zevra-sticky-price]', radio.dataset.price);
        const gallery = root.querySelector('[data-zevra-gallery]');
        if (gallery && gallery.dataset.currentVariant !== String(radio.value)) {
          gallery.dispatchEvent(new CustomEvent('zevra:variant-gallery', {
            detail: { variantId: radio.value }
          }));
        }
        const stickyImage = root.querySelector('[data-zevra-sticky-image]');
        const selectedMainImage = gallery?.querySelector('[data-zevra-main-image]');
        if (stickyImage && selectedMainImage) {
          const selectedImageSource = selectedMainImage.getAttribute('src');
          if (selectedImageSource) stickyImage.src = selectedImageSource;
          stickyImage.alt = `${radio.dataset.title || 'Selected colour'} ZEVRA Click Wallet`;
        }
        root.querySelectorAll('.add-to-cart-text__content > span > span').forEach((label) => {
          label.textContent = 'Add to cart';
        });
      };
      radios.forEach((radio) => radio.addEventListener('change', () => applyVariant(radio)));
      applyVariant(radios.find((radio) => radio.checked) || radios[0]);
    });

    const sticky = document.querySelector('[data-zevra-sticky-cart]');
    const purchaseTrigger = document.querySelector('[data-zevra-primary-purchase], #ZevraAddToCart');
    if (sticky && purchaseTrigger && sticky.dataset.zevraStickyReady !== 'true') {
      sticky.dataset.zevraStickyReady = 'true';
      const observer = new IntersectionObserver(([entry]) => {
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sticky.classList.toggle('visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }, { threshold: 0 });
      observer.observe(purchaseTrigger);
    }

    document.querySelectorAll('.zevra-mobile-menu').forEach((menu) => {
      if (menu.dataset.zevraMenuReady === 'true') return;
      menu.dataset.zevraMenuReady = 'true';
      const summary = menu.querySelector('summary');
      const syncState = () => summary?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      menu.addEventListener('toggle', syncState);
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.removeAttribute('open');
          syncState();
        });
      });
      syncState();
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.zevra-mobile-menu[open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.zevra-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
